import useUserHelp from "@rf-hooks/useUserHelp";
import { useMemo } from "react";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";

const usePermissionValidationDocuments = () => {
  const { USER_ROLE, USER } = useUserHelp();
  const { agents, isProject } = usePropertyDetailPage();
  const hasPermissionToManage = useMemo(() => {
    if (!isProject) {
      return false;
    }

    // Legacy rule
    if (USER.userData?.email === "gracielamarte@remaxm.net") {
      return true;
    }

    if (USER_ROLE.SUPER_ADMIN) {
      return true;
    }

    const isAgent = agents.some(agent => agent.id === USER.userData?.people_id);
    if (isAgent) {
      return true;
    }

    return false;
  }, [isProject, agents, USER, USER_ROLE]);

  return {
    hasPermissionToManage
  };
};

export default usePermissionValidationDocuments;
